export { OrderDetailTemplate } from './OrderDetailTemplate';
export type {
  OrderDetailItem,
  OrderDetailItemField,
  OrderDetailSummaryField,
  OrderDetailTemplateLabels,
  OrderDetailTemplateProps,
} from './OrderDetailTemplate.types';
